module.exports = __webpack_public_path__ + "static/img/practice.b94e089a.png";